import { Tag, type ThemingProps } from "@chakra-ui/react";
import { NeedStatus } from "../../autogen/bff-api";
import { useNeedStatusLabel } from "../../common/needs/useNeedStatusLabel";

const COLOR_SCHEME: Record<NeedStatus, ThemingProps["colorScheme"]> = {
  [NeedStatus.Draft]: "gray",
  [NeedStatus.Reported]: "blue",
  [NeedStatus.SentBack]: "orange",
  [NeedStatus.Approved]: "teal",
  [NeedStatus.Planned]: "cyan",
  [NeedStatus.FrameworkRecommended]: "purple",
  [NeedStatus.ProcurementCreated]: "green",
  [NeedStatus.UnderProcurement]: "teal",
  [NeedStatus.UnderCallOff]: "purple",
  [NeedStatus.Completed]: "teal",
  [NeedStatus.Rejected]: "red",
  [NeedStatus.Withdrawn]: "red",
};

export const NeedStatusTag = ({ status, size = "sm" }: { status: NeedStatus; size?: "sm" | "md" }) => {
  const label = useNeedStatusLabel();
  return (
    <Tag size={size} colorScheme={COLOR_SCHEME[status]} whiteSpace="nowrap">
      {label(status)}
    </Tag>
  );
};
